import { keyframes } from 'styled-components'
export const SlideInRight = keyframes`
  from {
    transform: translate3d(10rem, 0, 0)
  } 
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`

export const SlideInFromTopRight = keyframes`
  from {
    transform: translate3d(50%, -50%, 0);
  }
  to {
    transform: translate3d(0,0,0);
    opacity: 1;
  }
`
export const SlideOutToBottomLeft = keyframes`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(-50%,50%,0);
  }
`

export const FadeInFrame = keyframes`
  from {
    opacity:0;
  }
  to {
    opacity:1;
  }
`

export const FadeOutFrame = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const SlideUpFrame = keyframes`
  from {
    transform: translate3d(0, 50%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`

export const ExitSlideUpFrame = keyframes`
  from {
    transform: translate3d(0,0,0);
    opacity: 1;
  }
  to {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
`

export const SlideDownFrame = keyframes`
  from {
    transform: translate3d(0,0,0);
    opacity: 1;
  }
  to {
    transform: translate3d(0,100%,0);
    opacity: 0;
  }
`
